import React from 'react';
import ServiceLandingPage, { ServiceConfig } from '../components/ServiceLandingPage';

const config: ServiceConfig = {
  name: 'Charging Port Repair',
  icon: '🔌',
  tagline: 'Phone not charging? Get your charging port fixed at your doorstep.',
  description: 'A faulty charging port can leave you stranded with a dead phone. Whether it\'s loose, damaged, or blocked by debris, minto\'s technicians diagnose and fix charging port issues at your doorstep across Mumbai. We repair USB-C, Lightning, and Micro-USB ports on all major brands.',
  price: '499',
  warranty: '90-Day',
  benefits: [
    { icon: '🏠', title: 'Doorstep Service', desc: 'Technician comes to your location — home, office or café.' },
    { icon: '⚡', title: 'Same Day Repair', desc: 'Book before 6 PM and get your charging port fixed today.' },
    { icon: '🛡️', title: '90-Day Warranty', desc: 'All charging port repairs backed by 90 days warranty.' },
    { icon: '🔍', title: 'Accurate Diagnosis', desc: 'We first check if it\'s dust, software, or a hardware fault — so you only pay for what\'s needed.' },
    { icon: '⚙️', title: 'All Port Types', desc: 'Lightning, USB-C, Micro-USB — all port types supported.' },
    { icon: '💰', title: 'Transparent Pricing', desc: 'Price confirmed before we begin. No surprise charges.' },
  ],
  brands: ['iPhone', 'Samsung', 'OnePlus', 'Vivo', 'Oppo', 'Realme', 'Motorola', 'Xiaomi', 'Nothing', 'Google Pixel', 'Honor', 'Asus'],
  faqs: [
    { q: 'How do I know if my charging port is faulty?', a: 'Signs include cable not staying in, charging only at certain angles, very slow charging, or phone not charging at all.' },
    { q: 'Can you clean the port instead of replacing it?', a: 'Yes — if the issue is dust or debris, our technician will clean it first. Replacement is only done if necessary.' },
    { q: 'How long does charging port repair take?', a: 'Typically 30–60 minutes depending on the model.' },
    { q: 'Which areas in Mumbai do you cover?', a: 'We cover Andheri, Bandra, Dadar, Lower Parel, Borivali, Malad, Goregaon, Vile Parle, Ghatkopar, Kurla, Thane, Chembur and Navi Mumbai.' },
  ],
};

const ChargingPortRepairPage: React.FC = () => <ServiceLandingPage config={config} />;
export default ChargingPortRepairPage;
